// CS 22.11 -- uncapped share PDF: server renders in batches, then merges into ONE PDF.
export async function runSharePdfJob({ client, base, createBody, authBody = {}, params, onProgress }) {
  const { data: job } = await client.post(`${base}/share/pdf/jobs`, createBody, { params, timeout: 120000 });
  let done = job.done;
  onProgress?.(done, job.total);
  while (done < job.total) {
    const { data } = await client.post(`${base}/share/pdf/jobs/${job.job_id}/batch`, authBody, { params, timeout: 120000 });
    if (data.done <= done) throw new Error("PDF generation stalled. Please try again.");
    done = data.done;
    onProgress?.(done, job.total);
  }
  const resp = await client.post(`${base}/share/pdf/jobs/${job.job_id}/file`, authBody,
    { params, responseType: "blob", timeout: 300000 });
  return { blob: resp.data, total: job.total };
}

export async function shareErrorMessage(e) {
  let raw = e?.response?.data;
  if (raw instanceof Blob) {
    try { raw = JSON.parse(await raw.text()); }
    catch { raw = null; /* intentional: non-JSON error body -- generic message below */ }
  }
  const d = raw?.detail;
  return (d && (d.message || (typeof d === "string" ? d : null))) || e?.message || "Could not prepare PDF. Please try again.";
}
